import { Logo } from '@repo/ui/components/logo'
import { Mail } from 'lucide-react'
import type { FooterContent } from '@/components/footer/types'
import { GithubIcon, XIcon } from '@/components/icons'
import { appUrl, siteBrand } from './brand'

const canonicalHandlePattern = /^@[A-Za-z0-9._-]+$/

const toUrlFromHandle = (baseUrl: string, handle: string) => {
  if (!canonicalHandlePattern.test(handle)) return null
  return `${baseUrl}/${handle.slice(1)}`
}

const xHandle = '@zippityapp'
const githubHandle = '@zippity-app'

const derivedSocialLinks = [
  {
    name: 'X',
    href: toUrlFromHandle('https://x.com', xHandle),
    icon: XIcon,
  },
  {
    name: 'GitHub',
    href: toUrlFromHandle('https://github.com', githubHandle),
    icon: GithubIcon,
  },
].flatMap((social) => (social.href ? [{ ...social, href: social.href }] : []))

export const footerContent: FooterContent = {
  brand: {
    name: siteBrand.projectName,
    logo: <Logo className="w-6 h-6" />,
  },
  description: 'Scheduling for mobile work that protects the route, the buffer, and the next job.',
  sections: [
    {
      title: 'Product',
      links: [
        { text: 'How it helps', href: '/#how-it-works' },
        { text: 'Pricing', href: '/#pricing' },
        { text: 'Start free', href: appUrl.signUp },
      ],
    },
    {
      title: 'Company',
      links: [
        { text: 'Blog', href: '/blog' },
        { text: 'Contact', href: '/contact' },
      ],
    },
  ],
  social: [
    ...derivedSocialLinks,
    {
      name: 'Email',
      href: `mailto:hello@${siteBrand.domainName}`,
      icon: Mail,
    },
  ],
  copyright: `© 2026 ${siteBrand.projectName}. Built for days on the road.`,
  bottomLinks: [
    { text: 'Terms of Service', href: '/terms' },
    { text: 'Privacy Policy', href: '/privacy' },
  ],
}

export const footer = footerContent
